module.exports = __webpack_public_path__ + "static/12-c8df573d2dd95bed7047e758a822b39f.jpeg";